import { formatResourcePath } from 'src/utils/regex';
import { GeneralASError } from 'src/registry/types/axios';
import { MutationConfig } from 'src/lib/react-query';
import { useMutation } from '@tanstack/react-query';
import axios from 'src/lib/axios';
import { FinancialDocumentPdf } from 'src/features/financialDocuments/utils/types';

/*
 * A GET, but driven as a mutation: it is fired on demand from a click, may generate the PDF synchronously on
 * first call, and returns a short-lived signed URL that must never be served from cache.
 */
const RESOURCE = '/financial-documents/financial-document/:documentId/pdf/';

type MutationFnType = typeof mutationFn;

interface DTO {
    documentId: string;
}

const mutationFn = ({ documentId }: DTO): Promise<FinancialDocumentPdf> => {
    return axios.get(formatResourcePath(RESOURCE, { documentId }));
};

const useMutationHook = (options?: MutationConfig<MutationFnType, GeneralASError>) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useGetFinancialDocumentPdf, RESOURCE as FINANCIAL_DOCUMENT_PDF_RESOURCE };
